import { ASSET_TYPE } from '@24i/nxg-sdk-photon';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { useStore } from '../../context/ApplicationStore';

export type UseShouldSignIn = (assetType?: ASSET_TYPE) => boolean;

export const useShouldSignIn = (): UseShouldSignIn => {
    const { userData } = useStore();
    const guestModeFeature = useFeature('guestMode');
    const signInEnabled = useFeature('signIn');
    const isUserLogged = !!userData;
    const isSignInEnabled = signInEnabled?.enabled || signInEnabled === undefined;

    const shouldSignIn: UseShouldSignIn = (assetType) =>
        isSignInEnabled &&
        !guestModeFeature?.allowWatchContent &&
        !isUserLogged &&
        (!assetType || !guestModeFeature?.allowedContentToWatch?.includes(assetType));

    return shouldSignIn;
};
